import {
    getReadableTextClass,
    isValidHexColor,
    normalizeHexColor,
} from "./teamRoleColorUtils";

export default function TeamMemberNameBadge({
    name,
    colorHex,
    className = "",
    title,
}) {
    const displayName = typeof name === "string" ? name.trim() : "";
    const normalizedColor = normalizeHexColor(colorHex);
    const hasValidColor = isValidHexColor(normalizedColor);

    return (
        <span
            className={`inline-flex max-w-full items-center rounded-full px-2.5 py-0.5 text-sm font-medium ${
                hasValidColor
                    ? getReadableTextClass(normalizedColor)
                    : "bg-white text-slate-600 ring-1 ring-slate-200"
            } ${className}`}
            style={
                hasValidColor
                    ? { backgroundColor: normalizedColor }
                    : undefined
            }
            title={title ?? displayName}
        >
            <span className="truncate">{displayName}</span>
        </span>
    );
}
